import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { CardElement, injectStripe } from "react-stripe-elements";
import logo from "../assets/img/logo.svg";
import LoadingSpinner from "../dev/LoadingSpinner";
import CrossIcon from "../icon/Cross";

const { REACT_APP_URI = "/" } = process.env;

class CardForm extends Component {
    state = {
        response: "",
        responseCondition: "",
        isLoading: false,
        isDisabled: false,
        textCase: '',
    };
    componentDidMount() {
        this.setState({ textCase: this.getPaymentTextCase()})
    }
    getPaymentTextCase = () => {
        const {
            user: { plan, isTrialing, canITrial},
        } = this.props;
        if(isTrialing) { //是否試用中
            return 'trialing' //試用中
        }
        if(!canITrial) { //不可試用
            return plan === 'Free' 
                    ? 'trialedOrCanceled' //已試用過，未購買過
                    : 'customer' //已購買過
        }
        else return 'canTrial' //未試用，未購買，非試用中
    }
    handleSubmit = ev => {
        const {
            messages,
            user: { token },
            payment: { paymentApiCase, buyPlan, seatNumber },
        } = this.props;
        ev.preventDefault();
        this.setState({ isLoading: true }, () => {
            if (paymentApiCase === "upgrade") { // 升級 api 不需 stripe token
                this.setState({
                    isDisabled: true,
                    response: "",
                    responseCondition: ""
                });
                fetch(`${REACT_APP_URI}/upgradeTo/${buyPlan}/`, {
                    method: "post",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRFToken": token
                    },
                    body: JSON.stringify({
                        number: parseInt(seatNumber, 10)
                    }) /*seatNumber 是PM弄的 Agency Payment*/
                }).then(res => {
                    if (res.status === 200) {
                        this.setState(
                            {
                                isDisabled: true,
                                isLoading: false,
                                response: messages.payment_upgrade_success,
                                responseCondition: "pay_success"
                            },
                            () => {
                                if(buyPlan !== "Creator"){
                                    localStorage.setItem("InteRed_IsTourActive", true)
                                }
                                setTimeout(() => {
                                    window.location.reload();
                                }, 3000)
                            }
                        );
                    } else {
                        this.setState({
                            isDisabled: false,
                            isLoading: false,
                            response: messages.payment_unknown_error,
                            responseCondition: "pay_failed"
                        });
                    }
                });
                return 
            }
            if (this.props.stripe) { // 其他(payment & trial & changeCard) api 需要 stripe token
                this.props.stripe.createToken().then(res => {
                    if (res.error) {
                        this.setState({
                            isLoading: false,
                            isDisabled: false,
                            response: res.error.message,
                            responseCondition: "pay_failed"
                        });
                        return
                    }
                    this.setState({
                        isDisabled: true,
                        response: "",
                        responseCondition: ""
                    });
                    const {
                        token: { id }
                    } = res;
                    const url = paymentApiCase === 'changeCard' ? `${REACT_APP_URI}/accounts/changeCard/`
                                : `${REACT_APP_URI}/${paymentApiCase}/${buyPlan}/`
                    const PaymentResponse = paymentApiCase === 'trial' 
                            ? messages.trial_success_and_check
                            : messages.payment_success_and_check
                    //分成試用、購買、換卡
                    fetch(url, {
                        method: "post",
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json",
                            "X-CSRFToken": token
                        },
                        body: JSON.stringify({
                            stripeToken: id,
                            number: parseInt(seatNumber, 10)
                        }) /*seatNumber 是PM弄的 Agency Payment*/
                    }).then(res => {
                        if (res.status === 200) { //成功
                            this.setState(
                                {
                                    isDisabled: true,
                                    isLoading: false,
                                    response: PaymentResponse,
                                    responseCondition: "pay_success"
                                },
                                () => {
                                        if(buyPlan !== "Creator" && paymentApiCase !== 'changeCard'){
                                            localStorage.setItem("InteRed_IsTourActive", true)
                                        }
                                        setTimeout(() => {
                                            window.location.reload();
                                        }, 3000)
                                    }
                            );
                        } else { //失敗
                            this.setState({
                                isDisabled: false,
                                isLoading: false,
                                response:
                                    messages.payment_unknown_error,
                                responseCondition: "pay_failed"
                            });
                        }
                    });
                });
            } else {
                this.setState({
                    isDisabled: false,
                    isLoading: false,
                    response: messages.payment_unknown_error,
                    responseCondition: "pay_failed"
                });
            }
        });
    };
    render() {
        const { isLoading, response, isDisabled } = this.state;
        const {
            user: { plan, isTrialing, nextPayDate},
            payment: { paymentApiCase, paymentTextCase ,buyPlan, buyAmount },
            messages
        } = this.props;
        return (
            <Container>
                <Nav>
                    <IconWrap>
                        <Icon />
                    </IconWrap>
                    <Delete
                        onClick={() =>
                            this.props.dispatch({ type: "togglePaymentField", isPaymentActive: false, })
                        }
                    >
                        <CrossIcon />
                    </Delete>
                    <Title>InteRed.co </Title>
                    {(paymentApiCase === 'trial' || paymentApiCase === "payment" || paymentApiCase === "upgrade") && (
                        <React.Fragment>
                            <Subtitle id={"pay_type"} highlight margin>
                                {buyPlan} {messages.plan}{/* 文本: XXX方案 */}
                            </Subtitle>
                            <Subtitle highlight alignItems="center" margin textCenter>
                                {(paymentTextCase === "trialing" || paymentTextCase === "canTrial") && messages.free_trial_will_charge }
                                {/* //文本: ＊試用期過後每月自動收費，如不付費可隨時停止訂閱 */}
                                {(paymentTextCase === "trialedOrCanceled" || paymentTextCase === "dad") && messages.payment_debiting_every_month}
                                {/* {/*文本: ＊每個月將自動扣款 */}
                            </Subtitle>
                            <Subtitle alignItems="center" margin textCenter>
                                {paymentTextCase === "trialing" && `${messages.user_pay_free_trial_will_end} ${nextPayDate}`}
                                {/* 文本: ＊免費試用期至 2019-7-18 */}
                                {paymentTextCase === "dad" && <React.Fragment>
                                    <div>{messages.payment_upgrade_new_tips_01}</div>
                                    <div>{messages.payment_upgrade_new_tips_02} {nextPayDate} </div>
                                    {/* 文本: ＊升級將照時間比例計價並收費於 2019-7-18 */}
                                </React.Fragment>}
                                {paymentTextCase === "canTrial" && messages.free_trial_14days}
                                {/* 文本: ＊免費試用為期 14 天 */}
                            </Subtitle>
                        </React.Fragment>
                    )}
                </Nav>
                <SpinnerWrap isLoading={isLoading}>
                    <LoadingSpinner />
                </SpinnerWrap>
                {
                    <Form isLoading={isLoading} onSubmit={this.handleSubmit}>
                        <Wrap>
                            <Label>
                                {(plan === "Free" || paymentTextCase === "changeCard") && ( //初次輸入卡號或換卡
                                    <CardInput hidePostalCode={true} />
                                )}
                            </Label>
                            {paymentApiCase === "trial" && (
                                <Button id={`trial_now_${buyPlan}`} disabled={isDisabled}>
                                    {messages.free_trial}
                                    {/* 文本: 免費試用 */}
                                </Button>
                            )}
                            {paymentApiCase === "payment" && (
                                <Button id={`payment_now_${buyPlan}`} disabled={isDisabled}>
                                    Pay {buyAmount} USD
                                    {/* 文本: Pay $XXX */}
                                </Button>
                            )}
                            {paymentApiCase === "upgrade" && (
                                <Button id={isTrialing ? `trial_upgrade_${buyPlan}` : `payment_upgrade_${buyPlan}`} disabled={isDisabled}>
                                    {messages.user_upgrade} {buyAmount}
                                    {/* 文本: 升級 $XXX */}
                                </Button>
                            )}
                            {paymentApiCase === "changeCard" && (
                                <Button id="changeCard" disabled={isDisabled}>
                                    {messages.user_pay_change_card}
                                    {/* 文本: 更換卡片 */}
                                </Button>
                            )}
                        </Wrap>
                    </Form>
                }
                { (paymentTextCase === 'canTrial' && paymentApiCase === 'trial') && <SkipTrialWrap
                    onClick={() => this.props.dispatch({ type: 'togglePaymentField', isPaymentActive: true, paymentApiCase: 'payment', paymentTextCase: 'trialedOrCanceled', buyPlan: 'Brand', buyAmount: buyAmount })}
                > {/* 直接購買按鈕，切換至直接購買模式時隱藏，避免重複按 */}
                    <SkipTrialButton>
                        <span>{messages.skip_free_trial}</span>
                    </SkipTrialButton>
                </SkipTrialWrap>}
                <Response id={"pay_status"} isActive={response !== ""}>
                    {response}
                </Response>
            </Container>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        payment: state.Payment,
        messages: state.Messages,
        tour: state.Tour,
    };
};
export default injectStripe(connect(mapStateToProps)(CardForm));
const IconSize = 70;
const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transform: translateY(-20%);
    min-width: 300px;
    padding-bottom: 20px;
    background-color: rgb(245, 245, 245);
    border-radius: 5px;
`;
const Delete = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    top: 0px;
    right: 0px;
    cursor: pointer;
    &:hover {
        svg path {
            fill: #de0606;
        }
    }
`;
const Nav = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 50px 20px 20px 20px;
    background-color: rgb(233, 233, 233);
    border-radius: 5px 5px 0 0;
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 20px;
`;
const IconWrap = styled.div`
    position: absolute;
    top: ${-IconSize * 0.35}px;
`;
const Icon = styled.div`
    position: relative;
    width: ${IconSize}px;
    height: ${IconSize}px;
    background-color: #fff;
    border-radius: 100%;
    border: 0.5px solid #a0a0a0;
    &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: ${IconSize * 0.9}px;
        height: 62px;
        border-radius: 100%;
        border: 0.5px solid #a0a0a0;
        background: url(${logo});
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        background-color: #de0606;
    }
`;

const Title = styled.div`
    color: black;
    font-size: 18px;
`;
const Subtitle = styled.div`
    display: flex;
    flex-direction: column;
    color: ${props => (props.highlight ? "#de0606" : "787878")};
    font-size: ${props => (props.highlight ? "14px" : "12px")};
    margin: ${props => (props.margin ? "0 0 5px 0" : "")};
    align-items: ${({ alignItems }) => alignItems ? alignItems : ''};
    ${({ textCenter }) => textCenter ? "text-align: center" : ""};
`;
const Form = styled.form`
    display: ${({ isLoading }) => (isLoading ? "none" : "")};
`;
const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 20px;
`;
const Label = styled.label`
    width: 260px;
    color: #6b7c93;
    font-weight: 300;
    letter-spacing: 0.025em;
`;
const CardInput = styled(CardElement)`
    height: 40px;
`;
const Button = styled.button`
    white-space: nowrap;
    border: 0;
    outline: 0;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0 14px;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    color: #fff;
    border-radius: 4px;
    font-size: 15px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    background-color: ${({ disabled }) => (disabled ? "#a0a0a0" : "#de0606")};
    text-decoration: none;
    /* -webkit-transition: all 150ms ease;
    transition: all 150ms ease; */
    &:hover {
        ${({ disabled }) =>
            disabled
                ? ""
                : "color: #fff; cursor: pointer; background-color: rgba(222,6,6,.8); transform: translateY(-1px); box-shadow: 0 7px 14px rgba(50, 50, 93, .10), 0 3px 6px rgba(0, 0, 0, .08);"} /* color: #fff;
        cursor: pointer;
        background-color: rgba(222,6,6,.8);
        transform: translateY(-1px);
        box-shadow: 0 7px 14px rgba(50, 50, 93, .10), 0 3px 6px rgba(0, 0, 0, .08); */
    }
`;
const Response = styled.div`
    max-width: 260px;
    margin: ${props => (props.isActive ? "24px 0" : 0)};
    color: #de0606;
    transition: all 0.2s;
`;
const SpinnerWrap = styled.div`
    display: ${({ isLoading }) => (isLoading ? "" : "none")};
`;
const SkipTrialWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    margin-top: 10px;
    padding: 0 20px;
    font-size: 12px;
`
const SkipTrialButton = styled.div`
    display: flex;
    cursor: pointer;
    span {
        text-decoration: underline;
    }
    &:after {
        margin-left: 3px;
        content: '>';
    }
`


// WEBPACK FOOTER //
// ./src/Payment/CardForm.js